import { render, staticRenderFns } from "./review-pro-beseinfo.vue?vue&type=template&id=5b58a12d&scoped=true"
import script from "./review-pro-beseinfo.vue?vue&type=script&lang=js"
export * from "./review-pro-beseinfo.vue?vue&type=script&lang=js"
import style0 from "./review-pro-beseinfo.vue?vue&type=style&index=0&id=5b58a12d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b58a12d",
  null
  
)

export default component.exports